import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RowDealStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/row-deal-standard-quote/row-deal-standard-quote-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-row-deal-standard-quote-mobile',
  templateUrl: './row-deal-standard-quote-mobile.component.html',
  styleUrls: ['./row-deal-standard-quote-mobile.component.scss'],
})
export class RowDealStandardQuoteMobileComponent extends RowDealStandardQuoteWrapperComponent {
  constructor(
    notification: NotificationService,
    route: ActivatedRoute,
    menuService: MenusServices,
  ) {
    super(notification, route, menuService);
  }
}
